import {useService} from '@cindedi/react-application';
import type {MetaFunction, LoaderFunction} from '@remix-run/node';
import {json} from '@remix-run/node';
import {Link, useLoaderData} from '@remix-run/react';
import {PublicLayout} from '~/domains/organization/components/PublicLayout';
import {seoMeta} from '~/domains/organization/utilities/seoMeta';

export interface VideosLoaderData {
  videos: Organization.PublicVideoDto[];
}

export const meta: MetaFunction = function VideosMeta({matches}) {
  return seoMeta('videos', {title: 'Vídeos - Cindedi', description: 'Assista aos vídeos do CINDEDI sobre desenvolvimento humano e educação infantil. Aprenda com nosso conteúdo científico e didático!'}, matches);
};

export const loader: LoaderFunction = async function VideosLoader({context: {use}}) {
  const Video = use('Video');

  const videos = await Video.all();

  return json({
    videos: videos.sortBy('title'),
  });
};

export default function VideosView() {
  const {videos} = useLoaderData<VideosLoaderData>();
  useService('organization/titlebar').setTitle('Vídeos');

  return (
    <PublicLayout>
      <ul role="list" className="flex flex-col gap-8 md:gap-2">
        {videos.map((video) => (
          <li className="hover:bg-shade-3 bg-shade-2 rounded overflow-hidden" key={video.id}>
            <Link to={video.url} target="_blank">
              <div className="flex flex-col md:flex-row gap-2">
                <div
                  className="h-40 w-full md:w-64 bg-shade-4 md:rounded bg-no-repeat bg-cover md:m-2"
                  style={{backgroundImage: `url(${video.cover.url})`}}
                  aria-label={video.title}
                />
                <div className="px-2 py-3 flex flex-col w-full">
                  <span className="font-semibold text-primary-12">{video.title}</span>
                  <div className="flex gap-2 text-shade-11 text-sm items-center mt-1">
                    <span dangerouslySetInnerHTML={{__html: video.description}} />
                  </div>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </PublicLayout>
  );
}
